
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getQuestionBank, addQuestionBank, editQuestionBank, delQuestionBank } from '@/api/question';

@Component({
  name: 'SettingTemplateQuestionBank',
  components: {

  }
})
export default class extends Vue {
  private isDisabled:boolean=true
  private listData: any = []
  private showEdit = 0
  private choiceShow = false
  private form: any = {
    question_title: '',
    question_answer: [],
    question_type: '1'
  }
  private formChoice: any = {
    question_title: '',
    question_answer: [],
    question_type: '1'
  }
  private formQuestion:any={
    question_title: '',
    question_answer: [],
    question_type: '3'
  }
  private inputVisible = false
  private inputValue = ''
  private essayShow = false

  created() {
    this.getQuestionBank();
  }
  private getQuestionBank() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    getQuestionBank(pamars).then((res:any) => {
      if (res.data) {
        this.listData = res.data.list;
        this.isDisabled = parseInt(res.data.questionnaire_count) < 1;
      } else {
        this.isDisabled = true;
        this.listData = [];
      }
    }).catch(() => {
      this.isDisabled = true;
      this.listData = [];
    }
    );
  }
  private editQuestion(val:any, row:any) {
    this.showEdit = row.id;
    this.form = row;
  }
  private handleClose(index:any) {
    this.form.question_answer.splice(index, 1);
  }
  private deleteQuestion(val:any, row:any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let pamars:any = {};
        pamars.company_id = UserModule.getCompanyId;
        pamars.user_id = UserModule.getUserId;
        pamars.id = row.id;
        delQuestionBank(pamars).then((res:any) => {
          _this.showSuccessMsg(res.msg);
          _this.showEdit = 0;
          _this.getQuestionBank();
        }).catch(err => {
          _this.showErrorMsg(err.msg);
        });
      })
      .catch(() => {});
  }
  private modifyQuestion() {
    if (parseInt(this.form.question_type) !== 3) {
      if (this.form.question_answer.length < 2) {
        this.$message.warning('答案个数为2~6个');
        return;
      }
      if (this.form.question_answer.length > 5) {
        this.$message.warning('答案个数为2~6个');
        return false;
      }
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.id = this.form.id;
    pamars.question_type = this.form.question_type;
    pamars.question_title = this.form.question_title;
    pamars.question_answer = JSON.stringify(this.form.question_answer);
    editQuestionBank(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.showEdit = 0;
      this.getQuestionBank();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private cancelEdit() {
    this.showEdit = 0;
  }
  // private questionnaire(val: any) {
  // this.$router.push({
  //   path: 'questionnaire',
  //   query: { create: val }
  // });
  // this.$emit('toggle-page', val);
  // }
  private addChoiceHandle() {
    this.choiceShow = true;
    this.deleteEssay();
  }
  private answerCloseHandle(index: any) {
    this.formChoice.question_answer.splice(index, 1);
  }
  private answerAddHandle(type:number) {
    if (type === 1) {
      if (this.form.question_answer.length > 5) {
        this.$message.warning('答案个数为2~6个');
        return false;
      }
    }
    if (type === 2) {
      if (this.formChoice.question_answer.length > 5) {
        this.$message.warning('答案个数为2~6个');
        return false;
      }
    }
    this.inputVisible = true;
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus();
    });
  }
  private handleInputConfirm(type:number) {
    let inputValue = this.inputValue;
    if (type === 1) {
      if (inputValue) {
        this.form.question_answer.push({
          title: inputValue,
          select: 0
        });
      }
    }
    if (type === 2) {
      if (inputValue) {
        this.formChoice.question_answer.push({
          title: inputValue,
          select: 0
        });
      }
    }
    this.inputVisible = false;
    this.inputValue = '';
  }
  //
  private saveChoice() {
    if (parseInt(this.formChoice.question_type) !== 3) {
      if (this.formChoice.question_answer.length < 2) {
        this.$message.warning('答案个数为2~6个');
        return;
      }
      if (this.formChoice.question_answer.length > 5) {
        this.$message.warning('答案个数为2~6个');
        return false;
      }
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.question_type = this.formChoice.question_type;
    pamars.question_title = this.formChoice.question_title;
    pamars.question_answer = JSON.stringify(this.formChoice.question_answer);
    addQuestionBank(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.showEdit = 0;
      this.choiceShow = false;
      this.formChoice = {
        question_title: '',
        question_answer: [],
        question_type: '1'
      };
      this.getQuestionBank();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private deleteChoice() {
    this.choiceShow = false;
    this.formChoice = {
      question_title: '',
      question_answer: [],
      question_type: '1'
    };
  }
  private addEssayHandle() {
    this.essayShow = true;
    this.deleteChoice();
  }
  private deleteEssay() {
    this.essayShow = false;
    this.formQuestion = {
      question_title: '',
      question_answer: [],
      question_type: '3'
    };
  }
  private addQuestion() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.question_type = this.formQuestion.question_type;
    pamars.question_title = this.formQuestion.question_title;
    pamars.question_answer = JSON.stringify(this.formQuestion.question_answer);
    addQuestionBank(pamars).then((res:any) => {
      this.showEdit = 0;
      this.essayShow = false;
      this.formQuestion = {
        question_title: '',
        question_answer: [],
        question_type: '3'
      };
      this.getQuestionBank();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  resetForm() {
    for (var key in this.form) {
      if (this.form[key] instanceof Array) {
        this.form[key] = [];
      } else {
        this.form[key] = '';
      }
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
